var $ = require('js/sw-jquery/sw-jquery');

/**
 * data-sw-sso-login
 *
 * Used to login via facebook or google, as well as finish up the login process after we have received response from the 3rd party.
 *
 * This autoloader has some legacy assumptions. It expects to be in a form and expects there to be the following elements availible to it:
 *
 * .sso-error -- (To show the error message if one occurs)
 * .getKey -- (Flag to get session token from our server)
 * .login-dialog -- (Dialogue box to show message)
 * input[name="targetUrl"] -- (The url to redirect to after login)
 * input[name="isEdu"] -- (track if it's an edu login)
 * #google-app-id -- (google app id, this should be moved to sw.data)
 *
 *
 *
 * Usage:
 *
 *  data-sw-sso-login=<login type>
 *    Currently (facebook | google | finish)
 *
*   data-sw-sso-login-auth-type=<auth type>
 *     active tab to show (login | signup)
 *
 */
var FACEBOOK = 'facebook';
var GOOGLE = 'google';
var FINISH = 'finish';

var WAITING_CLASS = 'waiting';

let googleInitialized = false;

/**
 * This is called when we receive response from our server.
 * If it's a successful login it either redirects to the target url, reloads the page.
 * If confirmation is required it is displayed.
 *
 * @param response
 * @param $elem
 * @param authMethod
 * @returns {boolean}
 */
function handleSSOLogInResponse(response, $elem) {

  if(!response) {
    response = {};
    response.success = false;
    response.message = 'Oops something went wrong.';
  }

  if (response.success === false ){

    if (response.message) {
      $elem.removeClass(WAITING_CLASS).parent('div').find('.sso-error').show().html(response.message);
    }
    else {
      window.location.reload();
    }

    return false;
  }

  if (response.action === 'loginSuccess') {
    var targetUrl = response.targetUrl || $elem.data('swSsoLoginTargetUrl');

    if (targetUrl !== '') {
      window.location.href = '/forward?targetUrl=' + encodeURIComponent(targetUrl);
    } else {
      window.location.reload();
    }

    return true;
  }
  else if (response.action === 'confirmDialog') {
    if (! $('#fancybox-wrap').is(':visible')) {
      $.fancybox({
        'content': response.html,
        autoSize    : false,
        autoResize  : false,
        fitToView   : false,
        autoCenter  : true,
        leftRatio   : 0,
        padding     : 0,
        width       : 'auto',
        height      : 'auto',
        keys: {
          close  : [27]
        }
      });

    } else {

      $elem.parents('.login-dialog').html(response.html);
    }

  }

  return true;
}

/**
 * Called after google auth response triggered by googleSignInClick().
 * It will then submit a request to our servers to finalize and store the user info.
 *
 * @param authResult
 * @param $elem
 * @param options
 * @returns {boolean}
 */
function googleSignInCallBack(authResult, $elem, options) {
  $elem.addClass(WAITING_CLASS);

  var formAction = options.action;

  var getKey = false;
  var targetUrl = options.targetUrl;
  var isEdu = options.isEdu || '';

  var baseUrlSecure = options.baseUrlSecure;
  var googleAuthCallbackUrl = baseUrlSecure + '/login/json-google-login';

  var csrf = options.csrf;

  if (authResult.credential) {

    // Send the code to the server
    $.ajax({
      type:'post',
      xhrFields: {
        withCredentials: true
      },
      url: googleAuthCallbackUrl,
      success: function(swResponse) {
        return handleSSOLogInResponse(swResponse, $elem);
      },
      data: {
        token : authResult.credential,
        getKey: getKey,
        targetUrl: targetUrl || window.location.href,
        formAction: formAction,
        isEdu: isEdu,
        _csrf: csrf
      },
      dataType: 'json'
    });
  } else if (authResult.error) {
    return false;
  }
}

/**
 * Finish SSO Signup
 * External use onclick tpl.ssoConfirmModal.php
 * @param $elem
 * @param $form
 * @returns {boolean}
 */
function finishSSOSignUp($elem, $form) {

  $elem.addClass(WAITING_CLASS);
  var formData = $form.serialize();
  var url = $form.attr('action');

  $.ajax({
    type:'post',
    xhrFields: {
      withCredentials: true
    },
    data: formData,
    dataType: 'json',
    url: url,
    success:function (swResponse) {
      return handleSSOLogInResponse(swResponse, $elem, 'signup');
    }
  });


  return false;

}

/**
 * Google SSO Login click handler. Triggers google signin process.
 * @param $elem
 * @param options
 */
function googleSignInClick($elem, options) {
  $elem.addClass(WAITING_CLASS);

  function handleCredentialResponse(response) {
    googleSignInCallBack(response, $elem, options);
  }

  if (!googleInitialized) {
    const appId = $elem.data('swSsoGoogleApiClientId');

    window.google.accounts.id.initialize({
      client_id: appId,
      callback: handleCredentialResponse,
      auto_select: false
    });

    googleInitialized = true;
  }

  window.google.accounts.id.prompt();
}


/**
 * Facbook SSO login click handler. Triggers Facebook signin process.
 * @param $elem
 * @param options
 */
function fbLogIn($elem, options) {

  $elem.addClass(WAITING_CLASS);

  var formAction = options.action;

  var getKey = false;
  var targetUrl = options.targetUrl;
  var isEdu = options.isEdu || '';
  var csrf = options.csrf;

  var baseUrlSecure = options.baseUrlSecure;
  var facebookCallbackUrl = baseUrlSecure + '/login/json-fb-login';

  window.FB.login(function(response) {

      if (response.authResponse) {

        $.ajax({
          type:'post',
          xhrFields: {
            withCredentials: true
          },
          data: {
            fbResponse:  response.authResponse,
            getKey: getKey,
            targetUrl: targetUrl,
            formAction: formAction,
            isEdu: isEdu,
            _csrf: csrf
          },
          dataType: 'json',
          url: facebookCallbackUrl,
          success:function (swResponse) {
            return handleSSOLogInResponse(swResponse, $elem);
          }
        });

      } else {
        return false;
      }

    }, { scope: 'email' }
  );
}


$('body').on('click', '[data-sw-sso-login]', function (e) {
  var $target = $(e.target);
  var loginService = $target.data('swSsoLoginService');
  if (!loginService) {
    return;
  }
  // prevent submitting the regular login form to avoid unclear error messages
  e.preventDefault();

  var options = $(this).swDataParams('swSsoLogin', { excludePrefix: true });

  switch(loginService) {
    case FACEBOOK:
      fbLogIn($target, options);
      break;
    case GOOGLE:
      googleSignInClick($target, options);
      break;
    case FINISH:
      finishSSOSignUp($target, $(this));
      break;
  }
});
